module.exports = __webpack_public_path__ + "static/img/bg-pt.12570f02.png";